import React from 'react';
import styles from './Index.module.css';

const ErrorState = ({ error, onRetry }) => {
    return (
        <div className={styles.pageContainer}>
            <div className={styles.errorContainer}>
                <div className={styles.errorCard}>
                    <svg className={styles.errorIcon} viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                    <h2 className={styles.errorTitle}>Failed to Load Survey</h2>
                    <p className={styles.errorText}>{error}</p>
                    <button onClick={onRetry} className={styles.retryButton}>
                        <svg className={styles.buttonIcon} viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
                        </svg>
                        Retry
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ErrorState;